<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>产品列表</h4>
        </div>
        <div class="mg20">
            <div class="main-bd">
                <el-row class="searchSection" >
                    <el-form :inline="true" :model="searcherModel" class="demo-form-inline">
                        <el-form-item label="产品名称">
                            <el-input size="small" v-model="searcherModel.name" placeholder="产品名称"></el-input>
                        </el-form-item>
                        <el-form-item label="产品类型">
                            <el-select size="small" v-model="searcherModel.type_id" placeholder="请选择" clearable>
                                <el-option v-for="(item, key) in type_list" :key="key" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitSearch">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-row v-show="Acs('/products/create')" class="addBtn" >
                    <el-button type="primary" size="small" @click="create">+ 添加新产品</el-button>
                </el-row>
                <el-tabs @tab-click="handleClick" v-loading="loading">
                    <el-tab-pane label="产品列表">
                        <product-table :products='products' @handleEdit='handleEdit'
                            @handleDel='handleDelete'></product-table>
                    </el-tab-pane>
                    <el-tab-pane label="产品回收站">
                        <product-table :products='delProducts' :show='is_trash'
                            @handleActive='handleActive'></product-table>
                    </el-tab-pane>
                </el-tabs>
                <!-- Form -->
                <el-dialog title="产品信息" :visible.sync="dialogFormVisible" width="30%" center>
                    <el-form :model="form" :rules="rules" ref="form1">
                        <el-form-item label="产品名称" prop="name" :label-width="formLabelWidth">
                            <el-input v-model="form.name" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="Id" prop="id" hidden :label-width="formLabelWidth">
                            <el-input v-model="form.id" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="产品编码" prop="code" :label-width="formLabelWidth">
                            <el-input v-model.number="form.code" auto-complete="off" :disabled="form.id > 0"></el-input>
                        </el-form-item>
                        <el-form-item label="产品类型" prop="type_id" :label-width="formLabelWidth">
                            <el-select v-model="form.type_id" placeholder="请选择">
                                <el-option v-for="(item, key) in type_list" :key="key" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="允许配置" prop="allow_config" :label-width="formLabelWidth">
                            <el-radio v-model="form.allow_config" label="1">是</el-radio>
                            <el-radio v-model="form.allow_config" label="0">否</el-radio>
                        </el-form-item>
                        <el-form-item label="产品价格" prop="price" :label-width="formLabelWidth">
                            <el-input v-model.number="form.price" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="产品状态" prop="status" :label-width="formLabelWidth">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品排序" prop="display" :label-width="formLabelWidth">
                            <el-input v-model.number="form.display" placeholder="数字越大越靠前" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="产品介绍" prop="memo" :label-width="formLabelWidth">
                            <el-input type="textarea" v-model="form.memo" auto-complete="off"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="产品组件" prop="component" :label-width="formLabelWidth">
                            <el-input v-model="form.component" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="产品appid" prop="appid" :label-width="formLabelWidth">
                            <el-input v-model="form.appid" auto-complete="off"></el-input>
                        </el-form-item> -->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitForm('form1')" :loading="loading">确 定</el-button>
                    </div>
                </el-dialog>
                <el-row v-if="linkPage">
                    <pagination :linkPage="linkPage"></pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import ProductService from "~/services/product";
    import ProductTable from "~/views/product/table.vue";
    import CommonService from "~/services/common";
    import {isNumber} from 'util';

    export default {
        components: {
            Pagination,
            ProductTable,
        },
        data() {
            var validatePrice = (rule, value, callback) => {
                let reg = /^[0-9]*$/;
                if (!reg.test(value)) {
                    callback(new Error('产品价格应为正数或0'));
                } else {
                    callback();
                }
            };

            return {
                loading: false,
                total: 100,
                linkPage: null,
                searcherModel: {
                    name: '',
                    type_id: '',
                },
                products: [], //产品列表
                delProducts: [],//回收站列表
                dialogFormVisible: false,
                options: [{
                    value: 0,
                    label: '下架'
                }, {
                    value: 1,
                    label: '上架'
                }],
                is_trash: '',
                form: {
                    id: '',
                    name: '',
                    code: '',
                    memo: '',
                    price: '',
                    status: '',
                    allow_config: "",
                    is_deleted: '',
                    display:'', 
                    type_id: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入产品名称', trigger: 'blur'},
                        {min: 3, max: 255, message: '长度在 3 到 5 个字符', trigger: 'blur'}
                    ],
                    display:[
                        {required: true, message: '请输入产品排序', trigger: 'blur'},
                        {validator:(rule, value, callback) => {
                                let reg = /^[0-9]*$/;
                                if (!reg.test(value)) {
                                    callback(new Error('产品范围应为正数或0'));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'}
                    ],
                    code: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if(!value){
                                    callback('请输入产品编码');
                                }
                                if (!isNumber(value)) {
                                    callback('产品编码必须为数字');
                                }
                                if (value < 0) {
                                    callback("产品编码范围：1~127");
                                }// else if (value > 127) {
                                   // callback("产品编码范围：1~127");
                                //}2025-10.经过琦哥确认，这你不应该拦截
                                callback();
                            },
                            trigger: 'blur'
                        },
                    ],
                    // memo: [
                    //     {required: true, message: '请输入产品介绍', trigger: 'blur'},
                    //     {min: 3, max: 255, message: '长度在 3 到 5 个字符', trigger: 'blur'}
                    // ],
                    price: [
                        {
                            required: true,
                            validator: validatePrice,
                            trigger: 'blur'
                        }
                    ],
                    status: [
                        {required: true, message: '请选择产品状态', trigger: 'change'},
                    ],
                    type_id: [
                        {required: true, message: '请选择产品类型', trigger: 'change'},
                    ],
                    allow_config: [
                        {required: true, message: '请选择产品是否允许进行配置', trigger: 'change'},
                    ]
                },
                formLabelWidth: '120px',
                type_list: [],
            };
        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            if (this.is_trash) {
                this.getTrashList({
                    page: to.query["page"],
                    perPage: to.query["perPage"]
                });
            } else {
                this.initListData({
                    page: to.query["page"],
                    perPage: to.query["perPage"]
                });
            }
        },
        mounted() {
            this.initListData();
        },
        created: function () {
            this.getProductType();
        },
        methods: {
            //查询
            submitSearch() {
                let params = {
                    name: this.searcherModel.name,
                    is_deleted: (this.is_trash) ? 1 : 0,
                    type_id: this.searcherModel.type_id,
                }
                this.loading = true;
                ProductService.getList(params).then(res => {
                    if (this.is_trash) {
                        this.delProducts = res.data
                    } else {
                        this.products = res.data
                    }
                    this.linkPage = res._meta;
                    this.loading = false;
                });


            },
            //删除产品操作
            handleDelete(id) {
                this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                })
                    .then(() => {
                        ProductService.del(id).then(res => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.products = this.products.filter(function (item) {
                                return item.id != id;
                            });
                            this.initListData();
                        })
                    })
                    .catch(() => {
                    });
            },
            //表单提交
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.form.id) {
                            this.save();
                        } else {
                            this.addProduct();
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //添加产品弹窗
            create() {
                this.form = {}
                this.dialogFormVisible = true
            },
            //添加产品
            addProduct() {
                this.loading = true;
                ProductService.create(this.form).then(res => {
                    if (res.code == 0) {
                        this.products.unshift(res.data);
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        this.initListData();
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            //编辑
            handleEdit(data) {
                this.dialogFormVisible = true;
                this.form = Object.assign({}, data);
                this.form.allow_config = String(this.form.allow_config);
                console.log(this.form);
            },
            //保存操作
            save() {
                this.loading = true;
                var data = Object.assign({}, this.form);
                delete data.created_at;
                var i = this.products.findIndex(function (item) {
                    return item.id == data.id;
                });
                ProductService.update(data).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.initListData();
                        // this.products = [...this.products.slice(0, i), res.data, ...this.products.slice(i + 1)];
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            //默认加载
            initListData(params = {}) {
                this.loading = true;
                //加载产品列表
                ProductService.getList({
                    is_deleted: 0,
                    page: params.page,
                    perPage: params.perPage
                }).then(res => {
                    this.products = res.data
                    this.linkPage = res._meta;
                    this.loading = false;
                });
            },
            //TAB 切换
            handleClick(tab, event) {
                //这样写有点蛋疼
                if (tab.index == 1) {
                    this.is_trash = true;
                    this.getTrashList();
                } else {
                    this.is_trash = false;
                    this.initListData();
                }
            },
            //回收站列表
            getTrashList(params = {}) {
                ProductService.getList({
                    is_deleted: 1,
                    page: params.page,
                    perPage: params.perPage
                }).then(res => {
                    this.delProducts = res.data;
                    this.linkPage = res._meta;
                });
            },
            //产品激活
            handleActive(data) {
                this.$confirm('产品激活操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    data.is_deleted = 0;
                    delete data.created_at;
                    delete data.status;
                    ProductService.activeProduct(data).then(res => {
                        this.$message({
                            message: '激活成功',
                            type: 'success'
                        });
                        this.delProducts = this.delProducts.filter(function (item) {
                            return item.id != data.id;
                        });
                    })
                }).catch(() => {
                });
            },
            //产品类型列表
            getProductType() {
                //加载产品列表
                CommonService.getProductType().then(res => {
                    this.type_list = res.data
                });
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/product/index.vue